const attributes = {
  toast: {
    error: {
      badResponse: '[Attribut] Aktualisierungsfehler',
      create: {},
      edit: {},
    },
    success: {
      create: {},
      edit: {
        default: '[Attribut] wurde erfolgreich aktualisiert',
      },
      delete: {
        body: 'Attribute wurden erfolgreich gelöscht',
      },
    },
  },
  table: {
    headerButtons: {
      create: 'Erstellen',
      delete: {
        label: 'Löschen',
        deleteModal: {
          header: 'Attribute löschen',
          body: 'Sie sind dabei, {{attributes}} Attribute zu löschen',
        },
      },
      clear: {
        label: 'Löschen',
        clearModal: {
          header: 'Attribute löschen',
          body: 'Sie sind dabei, {{attributes}} Attribute zu löschen',
        },
      },
      import: 'Importieren',
    },
    actions: {
      delete: 'Löschen',
      export: 'Exportieren',
    },
    placeholder: {
      select: 'Auswählen',
    },
    headers: {
      name: 'Name',
      labels: 'Labels',
    },
    toolTip: {
      noPermission: 'Aktion nicht zulässig: Berechtigung erforderlich',
    },
  },
  form: {
    header: {
      createAttribute: {
        title: 'Erstellen',
      },

      updateAttribute: {
        title: 'Aktualisieren',
      },
    },
    footer: {
      confirmButtonText: {
        create: 'Einreichen',
        update: 'Einreichen',
      },
      resetButton: 'Erweitert zurücksetzen',
    },
    information: {
      details: {
        header: 'Allgemeine Informationen',
        fields: {
          name: 'Name',
          description: 'Beschreibung',
        },
      },
      aliases: {
        header: 'Zuordnung von Attributnamen',
        fields: {
          drivers: 'Fahrer',
          vehicles: 'Fahrzeuge',
          bookings: 'Buchungen',
        },
      },
      advanced: {
        header: 'Erweiterte Einstellungen',
        fields: {
          sharedRideRatio: 'Max. gemeinsame Zeitquote',
          maxSharedDistanceRatio: {
            label: 'Max. Sammelstrecken-Verhältnis',
            description:
              'Legt fest, wie viel länger eine Sammelfahrt im Vergleich zur Einzelstrecke sein darf. Beispiel: Wenn die Einzelstrecke 1 Meile beträgt und das Verhältnis 1,2 ist, darf die Sammelstrecke für diesen Passagier 1,2 Meilen nicht überschreiten.',
          },
          maxSinglePassengerTime: 'Maximale Fahrzeit für einen einzelnen Passagier',
          maxPassengers: 'Max. Passagiere',
          maxTripStops: 'Max. Stopps',
          tripBoardingTime: 'Einsteigezeit',
          tripBoardingTimeForSubsequentPassengers: 'Sekundäre Einsteigezeit',
          tripDropOffTime: 'Ausstiegszeit',
          tripDropOffTimeForSubsequentPassengers: 'Sekundäre Ausstiegszeit',
          attributeReassignment: 'Attribut-Umleitung aktivieren',
          attributeReassignmentDescription:
            'Wenn diese Einstellung aktiviert ist, wird bei Aktualisierungen bestimmter Buchungsattribute automatisch eine Umleitung der Fahrt ausgelöst. Ohne diese Einstellung führen Attributänderungen nicht zu einer Umleitung der Fahrt.',
          matchScore: 'Zuordnung von Fahrer-/Fahrzeug- und Buchungsattributen aktivieren',
          matchScoreDescription:
            'Wenn diese Einstellung aktiviert ist, berücksichtigt das System dieses Attribut bei der Zuordnung von Fahrern/Fahrzeugen zu Buchungen. Wenn sie deaktiviert ist, ignoriert das System dieses Attribut bei der Zuordnung.',
          maxBoardingDelay: 'Maximale Einsteigeverspätung',
          maxBoardingEarly: 'Maximal frühes Einsteigen',
          maxDropOffEarly: {
            label: 'Maximal frühes Aussteigen',
            description:
              'Maximale Anzahl von Minuten, die ein Fahrer im Verhältnis zur in der Reservierung festgelegten Ausstiegszeit früher ankommen darf.',
          },
          maxDropOffDelay: {
            label: 'Maximale Ausstiegsverzögerung',
            description:
              'Maximale Anzahl von Minuten, die ein Fahrer im Verhältnis zur in der Reservierung festgelegten Ausstiegszeit zu spät ankommen darf.',
          },
          minScore: 'Mindestpunktzahl',
          waitAndReturn: 'Warten & Rückfahrt',
          waitAndReturnDescription:
            'Die Dauer in Minuten, die ein Fahrer zwischen der Hinfahrt und der Rückfahrt bei einer „Warten & Rückfahrt“-Fahrt wartet.',
          off: 'Aus',
          maxPassengerAtOnce: 'Max. gleichzeitige Passagiere',
          maxPickupStops: 'Max. Abholstopps',
          maxDropoffStops: 'Maximale Zielstopps',
          groupWaitAndReturn: 'Warten & Rückfahrt gruppieren',
          groupWaitAndReturnOptions: {
            off: 'Aus',
            individualPair: 'Einzelpaar-Gruppierung',
            multiplePairs: 'Mehrere-Paare-Gruppierung',
          },
          onlyPrivate: 'Nur privat',
          maxSimultaneousBookings: 'Max. gleichzeitige Buchungen',
          sharedWith: 'Geteilt mit',
          willCallTimeOffset: 'Will-Call-Zeitversatz',
          leg: {
            label: 'Als Abschnitt aktivieren',
            description: 'Dieser Abschnitt ist bereits einem anderen Attribut zugewiesen.',
          },
        },
        modal: {
          title: 'Warten & Rückfahrt',
          body: {
            enableWaitAndReturn:
              "Sie sind dabei, die Einstellung 'Warten & Rückfahrt' zu aktivieren. Dies gilt für alle aktuellen und zukünftigen Buchungen, die als 'Warten & Rückfahrt' qualifizieren. Sind Sie sicher, dass Sie fortfahren möchten?",
            disableWaitAndReturn:
              "Sie sind dabei, die Einstellung 'Warten & Rückfahrt' zu deaktivieren. Dies wird aus allen aktuellen und zukünftigen Buchungen entfernt, die als 'Warten & Rückfahrt' identifiziert wurden. Sind Sie sicher, dass Sie fortfahren möchten?",
          },
        },
      },
    },
    valdations: {
      name: {
        required: 'Name ist erforderlich',
        name: 'Ungültiger Name',
      },
      unit: {
        required: 'Einheit ist erforderlich',
        name: 'Ungültige Einheit',
      },
      parameters: {
        required: 'Parameter sind erforderlich',
        name: 'Bitte überprüfen Sie die übergebenen Werte sorgfältig',
      },
    },
    create: {
      toastError: {
        message: 'Konnte nicht erstellt werden',
      },
      toastSuccess: {
        message: 'Erfolgreich erstellt',
      },
    },
    update: {
      formTabs: {
        generalInfo: 'Allgemein',
        advanced: 'Erweiterte Einstellungen',
        history: 'Verlauf',
      },
      toastError: {
        message: 'Aktualisierung nicht möglich',
      },
      toastSuccess: {
        message: 'Erfolgreich aktualisiert',
      },
    },
  },
  import: {
    title: 'Attribute-Import',
  },
};

export default attributes;
